var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-award-list"},[_c('inline-svg',{attrs:{"src":require('@/assets/social-proof/app-store-rating.svg')}}),_c('inline-svg',{attrs:{"src":require('@/assets/social-proof/medtech-award.svg')}}),_c('inline-svg',{attrs:{"src":require('@/assets/social-proof/amount-happy-users.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }